import { FormControl, Select } from '@chakra-ui/react'
import type { PersonAdditionalData } from 'BrokerTsLib/src/dtos'
import { SelectionType } from 'BrokerTsLib/src/enums'
import type { FieldError } from 'BrokerTsLib/src/rhf'
import { useFormContext } from 'BrokerTsLib/src/rhf'

import { FormLabel } from '../components/FormLabel'
import type { InputGroupProps } from '../components/InputGroup'
import { InputGroup } from '../components/InputGroup'
import { useSelections } from '../hooks'
import { useNameof } from '../hooks/useNameof'

export const InsureeName = ({
  personPrefix,
  showTitles = false,
  ...props
}: InputGroupProps & {
  personPrefix: string
  showTitles?: boolean
}) => {
  const { data: dataTitles, isLoading: isLoadingTitles, isFetching: isFetchingTitles } = useSelections(SelectionType.TitleBefore)

  const pnameof = useNameof<PersonAdditionalData>(personPrefix)

  const {
    register,
    getValues,
    getFieldState
  } = useFormContext()



  return (
    <>
      {showTitles &&
        <FormControl>
          <FormLabel>Titul před jménem</FormLabel>
          {(dataTitles?.length ?? 0) > 0 &&
            <Select
              {...register(pnameof(x => x.titleBefore))}
              isDisabled={props.isDisabled}
              defaultValue={getValues(pnameof(x => x.titleBefore)) ?? ''}
            >
              <option value=''>Vyberte</option>
              {dataTitles?.map((item) => (
                <option value={item.value?.toString()} key={item.id}>{item.value}</option>
              ))}
            </Select>
          }
          {/* <InputGroup placeholder="Např. Ing." htmlSize={8} {...register(pnameof(x => x.titleBefore))} {...props} /> */}
        </FormControl>
      }

      <FormControl isInvalid={!!getFieldState(pnameof(x => x.name)).error} isRequired>
        <FormLabel htmlFor={pnameof(x => x.name)}>Jméno</FormLabel>
        <InputGroup
          id={pnameof(x => x.name)}
          placeholder="Jméno"
          autoComplete="given-name"
          errors={getFieldState(pnameof(x => x.name)).error as FieldError}
          {...props}
          {...register(pnameof(x => x.name))}
        />
      </FormControl>

      <FormControl isInvalid={!!getFieldState(pnameof(x => x.surname)).error} isRequired>
        <FormLabel htmlFor={pnameof(x => x.surname)}>Příjmení</FormLabel>
        <InputGroup
          id={pnameof(x => x.surname)}
          placeholder="Příjmení"
          autoComplete="family-name"
          errors={getFieldState(pnameof(x => x.surname)).error as FieldError}
          {...props}
          {...register(pnameof(x => x.surname))}
        />
      </FormControl>

      {showTitles &&
        <FormControl>
          <FormLabel>Titul za jménem</FormLabel>

          <InputGroup placeholder="Např. PhD." htmlSize={8} {...register(pnameof(x => x.titleAfter))} {...props} />
        </FormControl>
      }
    </>
  )
}
